export default __webpack_public_path__ + "static/media/continuousImprovement_icon.53c5c19e.png";